
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { CustomValidator } from 'src/app/_common/custom-validators';
import { URLS } from 'src/app/_config/api.config';
import { ApiService } from 'src/app/services/api-data.service';
import { CommonService } from 'src/app/services/common.service';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { catchError, debounceTime, distinctUntilChanged, filter, finalize, map, switchMap, throttleTime } from 'rxjs/operators';


declare var bootstrap: any; // Bootstrap JS types

@Component({
  selector: 'app-benificary-new-charity',
  templateUrl: './benificary-new-charity.component.html',
  styleUrls: ['./benificary-new-charity.component.scss']
})
export class BenificaryNewCharityComponent implements OnInit {

  modalSizeClass = 'xl';
  addAnotherCharityActive = false;
  searching=false
  charityForm!: FormGroup;
  organizationTypes = ['Non-Profit', 'Religious', 'Educational', 'Medical'];
  cities = ['New York', 'Washington DC'];
  states = ['Texas', 'Florida', 'Alaska'];
  //
  searchText: string = '';
  searchTextVal: string = '';
  searchTerm: string = '';

  //infintie scroll variable declaration below
  search$ = new Subject<string>();
  scroll$ = new Subject<void>();
  pageSize = 5;
  currentPage = 1;
  currentSearchTerm = '';
  loading = false;
  allLoaded = false;
//infintie scroll variable declaration above

  favCharityNameList: any = [];
  selectedOrganizationType = 'Select';
  isOpen = false;
  isEditDisabled = false;
  charityCategoryList = [];
  listenerInitialized = false;
  searchControl = new FormControl('');
  searchSub: Subscription | null = null;
  organizationTypeId: any;
  orgId: any;
  addCharityOrgId: any = null;
  @Output() messageEvent = new EventEmitter<any>();
  @Output() modalClosed = new EventEmitter<void>();
  @Input() selectedCharitiesData:any;
  showNoResult = false;
  @ViewChild('dropdownList') dropdownList!: ElementRef;
  //
  private subscription: Subscription = new Subscription()

  constructor(private fb: FormBuilder,
    private dataService: ApiService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private elRef: ElementRef,
    public commonService: CommonService,
  ) { }

  ngOnInit(): void {
    this.charityForm = this.fb.group({
      charityName: ['', [Validators.required, CustomValidator.noWhiteSpaceValidator]],
      organizationType: ['', [Validators.required, CustomValidator.nameValidator]],
      city: ['', [Validators.required, CustomValidator.nameValidator, CustomValidator.noWhiteSpaceValidator]],
      state: ['', [Validators.required, CustomValidator.nameValidator, CustomValidator.noWhiteSpaceValidator]],
    });
    this.getCharityCategoryList();
    this.charityForm.controls['city'].enable();
    this.charityForm.controls['state'].enable();
    this.charityForm.controls['organizationType'].enable();

    //infinite scroll code below
    this.search$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      filter(term => term.trim().length > 0),
      switchMap(term => {
        this.currentSearchTerm = term;
        this.currentPage = 1;
        this.favCharityNameList = [];
        this.allLoaded = false;
        this.loading = true;
        // ✅ Return the observable
        return this.getFavCharitySearch({ search: term, page: this.currentPage, size: this.pageSize });
      })
    ).subscribe(({ results, totalCount }) => {
      this.favCharityNameList = results;
      this.allLoaded = results.length >= totalCount;
      this.showNoResult = results.length === 0;
      this.loading = false;
    });
    // SCROLL STREAM
    this.scroll$.pipe(
      throttleTime(500),
      filter(() => !this.loading && !this.allLoaded),
      switchMap(() => {
        this.currentPage += 1;
        this.loading = true;
        return this.getFavCharitySearch({ search: this.currentSearchTerm, page: this.currentPage, size: this.pageSize });
      })
    ).subscribe(({ results, totalCount }) => {
      this.favCharityNameList = [...this.favCharityNameList, ...results];
      this.allLoaded = this.favCharityNameList.length >= totalCount;
      this.loading = false;
    });
  }

  ngAfterViewInit() {
    const modalEl = document.getElementById('childModal');
    if (modalEl) {
      modalEl.addEventListener('hidden.bs.modal', () => {
        this.modalClosed.emit();
      });
    }
  }

  @ViewChild('childModalRef', { static: true }) modalElement!: ElementRef;

  openModal() {
    this.showNoResult=false;
    this.searching=false;
    const modal = new bootstrap.Modal(document.getElementById('childModal'));
    modal.show();
  }

  getCharityCategoryList() {
    let params = {
    }
    // this.isLoading = true;
    this.subscription.add(
      this.dataService.get(URLS.getcharityCategory, params).subscribe(data => {
        if (data['code'] == 200) {
          if (data['data']) {
            this.charityCategoryList = data['data'];
          }
        } else {
          this.toastr.error(data['message'], "Error");
          // this.isLoading = false;
        }
      }, error => {
        this.toastr.error(error['message'], "Error");
        // this.isLoading = false;
      })
    )
  }

  onSearchInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
  
    // Prevent leading space
    if (value.startsWith(' ')) {
      input.value = value.trimStart(); // Update the input field
      this.searchControl.setValue(input.value, { emitEvent: false }); // Update formControl without triggering valueChanges again
      this.searchText = input.value;
    }

     this.charityForm.controls['city'].setValue(null);
        this.charityForm.controls['city'].enable();
        this.charityForm.controls['state'].setValue(null);
        this.charityForm.controls['state'].enable();
        this.charityForm.controls['organizationType'].setValue(null);
        this.charityForm.controls['organizationType'].enable();
        this.selectedOrganizationType =  'Select';
        this.organizationTypeId = null;
        this.addCharityOrgId = null;
  
    // this.charityFilterOptions(); // Call your original search logic
    this.charityForm.controls['city'].enable();
    this.charityForm.controls['state'].enable();
    this.charityForm.controls['organizationType'].enable();
    this.search$.next(value);
  }

  charityFilterOptions() {
    if (!this.listenerInitialized) {
      this.listenerInitialized = true;
      this.searchSub = this.searchControl.valueChanges
        .pipe(
          debounceTime(700),
          distinctUntilChanged(),
          filter((term: string | null) => !term || term.length === 0 || term.length > 2)
        )
        .subscribe(searchTerm => {
          this.searchTerm = searchTerm;
          if (searchTerm?.length === 0) {
            this.favCharityNameList = [];
          } else {
            if (this.searchTextVal !== searchTerm && searchTerm !=null )  {
              this.getFavCharitySearch({ search: searchTerm });
            }
          }
        });
      console.log(this.searchSub);
    }
  }

  preventSpaceInInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
  
    // Prevent leading space
    if (value.startsWith(' ')) {
      input.value = value.trimStart(); // Update the input field
      this.searchControl.setValue(input.value, { emitEvent: false }); // Update formControl without triggering valueChanges again
      this.searchText = input.value;
    }
  }

  selectOrganizationType(event: any, option: any) {
    event.stopPropagation();
    this.isOpen = false;

    this.selectedOrganizationType = option.name;
    this.organizationTypeId = option._id;
  }



  selectCharityOption(event: any, option: any) {
    event.stopPropagation();
    if (option) {
      if (this.selectedCharitiesData) {
        const selectedOrgIds = this.selectedCharitiesData
          .flatMap(entry => {
            const row = Array.isArray(entry)
              ? entry
              : Array.isArray(entry?.AddColumnData)
                ? entry.AddColumnData
                : [];

            const orgIdItem = row.find(item => item?.label === 'orgId' && item.answer);
            return orgIdItem ? [orgIdItem.answer] : [];
          });

        // Now use this condition in your logic
        if (
          option.isAddedToCard ||
          (option._id && selectedOrgIds.includes(option._id))
        ) {
          this.toastr.error(
            `This charity already added. Please select another charity.`,
            "Error"
          );
          return;
        }
      }


      this.searchText = option.orgName;
      this.searchTextVal = option.orgName;
      this.orgId = option._id;

      this.charityForm.controls['charityName'].setValue(option.orgName);
      this.charityForm.controls['city'].setValue(option.orgCity);
      if(option.orgCity)
      this.charityForm.controls['city'].disable();
      this.charityForm.controls['state'].setValue(option.orgState);
      if(option.orgState)
        this.charityForm.controls['state'].disable();  
      this.charityForm.controls['organizationType'].setValue(option.orgType);
      if(option.orgType)
        this.charityForm.controls['organizationType'].disable();
      this.selectedOrganizationType = option['orgType'] ? option['orgType'] : 'Select';
      this.organizationTypeId = option['charitableCategoryId'];
      this.addCharityOrgId = option['_id'];
    }

    this.favCharityNameList = [];
  }

  
  getFavCharitySearch(dataParams?: any): Observable<{ results: any[], totalCount: number }> {
    const params = { ...(dataParams || {}), isCardAdded: true };
    this.searching = true;

    return this.dataService.get(URLS.favCharitySearch, params).pipe(
      map((data: any) => {
        const results = data['data']['result'] || [];
        const totalCount = data['data']['totalCount'] || 0;

        if (results.length === 0) this.showNoResult = true;
        else this.showNoResult = false;

        if (this.selectedCharitiesData) {
          const selectedOrgIds = new Set<string>();
          this.selectedCharitiesData.forEach(entry => {
            let row: any[] = [];
            if (Array.isArray(entry)) row = entry;
            else if (entry?.AddColumnData) row = entry.AddColumnData;

            const orgIdItem = row.find(item => item.label === 'orgId');
            if (orgIdItem?.answer) selectedOrgIds.add(orgIdItem.answer);
          });
          return { results: results.filter(item => !selectedOrgIds.has(item._id)), totalCount };
        }

        return { results, totalCount };
      }),
      finalize(() => {
        this.searching = false;
      }),
      catchError(err => {
        this.toastr.error(err['message'], 'Error');
        return of({ results: [], totalCount: 0 });
      })
    );
  }

  toggleDropdown(event: MouseEvent) {
    event.stopPropagation();
    this.isOpen = !this.isOpen;
  }

  onSubmit(): void {
    if (this.charityForm.controls['charityName'].value == null)
      this.charityForm.controls['charityName'].setValue(this.searchText);
    if (this.charityForm.valid) {
      let data = {
        name: this.charityForm.controls['charityName'].value,
        orgId: this.addCharityOrgId == null ? 'customCharity' : this.addCharityOrgId,
      }
      if (this.addCharityOrgId == null) {
        data['city'] = this.charityForm.controls['city'].value;
        data['state'] = this.charityForm.controls['state'].value;
      }

      this.messageEvent.emit(data);
      this.resetForm();
      this.addCharityOrgId=null;
    } else {
      this.charityForm.markAllAsTouched();
    }
  }

  resetForm() {
    if (this.charityForm) {
      this.charityForm.reset();
    }
  }

  closeDropdown() {
    this.showNoResult = false;
    this.favCharityNameList = [];
  }

  closeButtonClicked(){
    this.search$.next(''); 
     this.closeDropdown();
     this.modalClosed.emit();
  }

  onDropdownScroll(event: any) {
    const element = event.target;
    if (element.scrollTop + element.clientHeight >= element.scrollHeight - 10) {
      this.scroll$.next();
    }
  }
}
